module.exports = __webpack_public_path__ + "media/site_templates/www.bathroomrenovations.biz/images/splash-dc1b78d59ed22c4a801e380cb4d5ace3.jpg";